import { FormLabel, OptionType, SearchableSelect, Textarea, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateTrackerIntegrationComponent
} from "entities/template";
import React, { useContext, useMemo } from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { trackerIntegrationContext } from "../../../../lib/providers/tracker-integration-provider";
import { TagSelectField } from "../../form_fields/tag_select_field/tag_select_field";
import styles from "./component_form_tracker_integration.module.scss";

interface IComponentFormTrackerIntegrationProps {
    component: ITemplateTrackerIntegrationComponent;
    componentList: ITemplateComponent[];
    onChange: (component: ITemplateComponent) => void;
    triggerValidate: number;
}

export const ComponentFormTrackerIntegration: React.FC<IComponentFormTrackerIntegrationProps> = React.memo(({
                                                                                                                component,
                                                                                                                triggerValidate,
                                                                                                                componentList,
                                                                                                                onChange
                                                                                                            }) => {
    const t = useComponentsTranslations();
    const { ticketFields, trackerFieldsLoading } = useContext(trackerIntegrationContext);

    const onFieldChange = (value: Partial<ITemplateTrackerIntegrationComponent>) => {
        onChange({
            ...component,
            ...value
        });
    };

    const ticketFieldOptions = useMemo(() => {
        return ticketFields.map(field => {
            return {
                value: field.id,
                label: field.name
            };
        });
    }, [ticketFields]);

    return <div className={styles.container}>
        <FormLabel title={t("trackerField")} className={styles.defaultValueSelect} required={true}>
            <SearchableSelect
                options={ticketFieldOptions}
                loading={trackerFieldsLoading}
                triggerValidate={triggerValidate}
                validate={true}
                optionValue={component.startrekFields ? ticketFieldOptions.find((o) => o.value === component.startrekFields?.id) as OptionType : undefined}
                onChange={(id) => {
                    const startrekFields = (id ? ticketFields.find((o) => o.id === id) : undefined);
                    onFieldChange({ startrekFields });
                }}
                isMulti={false}
                hideClearIcon={false}
                isSearchable={true}
            />
        </FormLabel>
        <TagSelectField
            title={t("addParameter")}
            currentComponent={component}
            componentList={componentList}
            fullList={true}
            includeAutonumber={true}
            onChange={(val) => {
                if (val) {
                    const tagWrapper = `<?${val}?>`;
                    const textWithVariables = component.textWithVariables ? component.textWithVariables + tagWrapper : tagWrapper;
                    onFieldChange({ textWithVariables });
                }

            }}
            forceEmpty={true}/>
        <FormLabel title={t("textWithVariables") + " *"}>
            <Textarea
                value={component.textWithVariables}
                onChange={(e) => onFieldChange({ textWithVariables: e.target.value })}
            />
            <div className={styles.subLabel}>{"* " + t("textWithVariablesDescription")}</div>
        </FormLabel>
        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       value={component.name}
                       disabled={true}
                       view="outline"/>
        </FormLabel>
    </div>;
});
